import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { get } from '../services/api';
import PowerfulTable from './PowerfulTable/PowerfulTable';
import Loading from './Loading/Loading';
import colors from '../utils/colors';

export default function NewsList() {
  const [news, setNews] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchNews = async () => {
      // 1. Initial load
      const initialNews = await get(`/admin/news?limit=50`);
      if (isMounted && initialNews) {
        const formatted = initialNews.map(n => ({
          newsId: n.newsId,
          title: n.title,
          createdAt: n.createdAt,
          hasPoll: n.poll ? 'Oui' : 'Non',
        }));
        setNews(formatted);
      }

      // 2. Background load
      get(`/admin/news?limit=10000&skip=50`).then(rest => {
        if (isMounted && rest && rest.length > 0) {
          const formattedRest = rest.map(n => ({
            newsId: n.newsId,
            title: n.title,
            createdAt: n.createdAt,
            hasPoll: n.poll ? 'Oui' : 'Non',
          }));
          setNews(prev => {
            const existingIds = new Set((prev || []).map(n => n.newsId));
            const newOnes = formattedRest.filter(n => !existingIds.has(n.newsId));
            return [...(prev || []), ...newOnes];
          });
        }
      });
    };

    fetchNews();
    return () => { isMounted = false; };
  }, []);

  if (!news) return <Loading />;

  return (
    <div>
      <div style={{ marginLeft: 20 }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingRight: 20 }}>
          <h2>Actualités ({news.length})</h2>
          <Link to="/news/new" style={{ textDecoration: 'none' }}>
            <div style={{
              backgroundColor: colors.green,
              color: 'white',
              padding: '10px 20px',
              borderRadius: 5,
              fontWeight: 'bold',
              cursor: 'pointer'
            }}>
              Ajouter une actualité
            </div>
          </Link>
        </div>

        {news.length > 0 ? (
          <PowerfulTable
            data={news}
            types={{
              title: { name: 'Titre' },
              createdAt: { name: 'Date de création' },
              hasPoll: { name: 'Sondage ?' },
            }}
            redirect={'news'}
            redirectKey={'newsId'}
          />
        ) : (
          <p style={{ width: '100%', textAlign: 'center' }}>Aucune actualité.</p>
        )}
      </div>
    </div>
  );
}
